import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table, CommonErrors } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn";
import {
    useForm,
    useFetch,
    useGrid,
    useResource,
    usePopup,
    useStore,
    useToast,
    useAuth,
    useModal,
    useTab,
    usePage,
} from "@/comn/hooks";
import {
    BASE,
    URLS,
    APIS,
    SF_HS_CTGR,
    SG_HS_CODE_LIST,
} from "@/tz/go/egaz/osci/lpco/hscd/ctgr/service/OsciHscdCtgrService";

/**
 * HS Code Category Registering
 * !== HS 코드 카테고리 등록 ==!
 */
export const OSCI0204005S = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0004"],
    });
    const pgeTitle = "Registering Control HS Code"; // Page Title !== 페이지 타이틀 ==!
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    const [hsCdList, setHsCdList] = useState(comnUtils.getGridData([]));

    /*
     * Code Resource
     * !== 사용할 Code 정의 ==!
     */
    useResource({
        defaultSchema: [{ area: "hsCd" }, { area: "comnCd", comnCd: "OSC0130" }],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Registering HS Code Form !== HS 신청 Form==!
        hsCdForm: useForm({
            defaultSchema: SF_HS_CTGR,
            defaultValues: {
                orgCd: auth.get("orgCd"),
                orgNm: auth.get("orgNm"),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Registering HS Code List !== Item Tab HS Code 등록 ==!
        appHsCodeList: useGrid({
            defaultSchema: SG_HS_CODE_LIST,
            page: 0,
            size: 10,
        }),
    };
    const render = {
        hsCdList: {
            head: {},
            cell: {},
            edit: {},
            row: (row: any, context: any) => {
                // row : 해당 row 의 데이터(rowValues)
                // return 값이 true 이면 row 보임
                // return 값이 false 이면 row 숨김
                // context 의 속성을 변경하여 row 의 바탕색 변경 가능
                if (row.prcsRoleTpCd === "SU" || row.prcsRoleTpCd === "AP") {
                    //context.backgroundColor = "blue"; // 3가지 색상 옵션 red , yellow , blue
                }
                return true;
            },
            checkbox: (row: any) => {
                // row : 해당 row 의 데이터(rowValues)
                return true; // !(row.deletableYn === "N");
            },
        },
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getHsCtgrItmList: useFetch({
            api: () => {
                return APIS.getHsCtgrItmList({ ...form.hsCdForm.getValues() });
            },
            onSuccess: (data) => {
                console.log("getOgaHsCdList onSuccess ", data.list?.content);
                // form.lpcoInfoRgsr.setValues(data.appInfo.content?.info);
                const resultList = data.list?.content || [];
                setHsCdList(comnUtils.getGridData(resultList));
            },
            onError: () => {},
            showToast: false,
        }),

        saveHsCtgrItmList: useFetch({
            api: (data) => APIS.saveHsCtgrItmList({ ...data }),
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00006" /**Processed successfully. */,
                    onConfirm: () => {
                        // navigate(URLS.osci0204005s);
                        handler.setInit();
                    },
                    onCancel: () => {
                        navigate(URLS.osci0204005s);
                    },
                });
            },
            onError: (error) => {
                console.log(error.response?.data?.errorMessage);
                const msg = error.response?.data?.errorMessage || "msg.osc.00015";
                modal.openModal({
                    content: msg,
                });
            },
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Delete Item list deletion event !== 품목 목록 삭제 이벤트 ==!
        click_Btn_DeleteGridAppHsCodeList: () => {
            const seltList: any[] = grid.appHsCodeList.getChecked() || [];
            if (comnUtils.isEmpty(seltList)) {
                modal.openModal({ content: "msg.osc.00009" });
                return;
            }

            grid.appHsCodeList.deleteRow("checkbox");

            // modal.openModal({
            //     content: "msg.osc.00095",
            //     onConfirm: () => {
            //         grid.appHsCodeList.deleteRow("checkbox");
            //     },
            // });
        },
        // Save Component !== Additional Info 저장 ==!
        saveHsCtgrItmList: form.hsCdForm.handleSubmit(async () => {
            const hsCdList = grid.appHsCodeList.getData();

            let bCheck = true;
            if (!hsCdList || hsCdList.length == 0) {
                // Please enter Hs Code. !== HS CODE를 입력하세요. ==!
                bCheck = false;
                modal.openModal({
                    content: "msg.osc.00055",
                });
            } else {
                // grid validate
                let errResult = grid.appHsCodeList.validate() || {};
                errResult["errors"] = errResult?.errors || [];

                const hsCdList = grid.appHsCodeList.getViewData();
                /* msg.osc.00013 Mandatory fields */
                const duplMap: { [key: string]: boolean } = {};
                let idx = 1;
                for (const item of hsCdList) {
                    if (item.hsCd) {
                        const val = item.hsCd;

                        if (val && duplMap[val]) {
                            errResult.errors.push(lpcoUtils.getErrorObj(idx, "L_HS_CD", "msg.osc.00017", val));
                        } else {
                            duplMap[val] = true;
                        }
                    }
                    // msg.osc.00057 Please check the validity period.
                    if (item.appdStrtDt && item.appdEndDt) {
                        // 비교
                        if (comnUtils.compareDate(item.appdStrtDt, item.appdEndDt) == -1) {
                            errResult.errors.push(
                                lpcoUtils.getErrorObj(idx, "L_VLD_STRT_DT", "msg.osc.00057", item.appdStrtDt),
                                lpcoUtils.getErrorObj(idx, "L_VLD_END_DT", "msg.osc.00057", item.appdEndDt),
                            );
                        }
                    }
                    idx++;
                }

                if (errResult && errResult.errors?.length > 0) {
                    // sort by row
                    errResult.errors = lpcoUtils.errorListSortByRow(errResult.errors);
                    // error layer popup
                    modal.openModal({
                        content: <CommonErrors {...errResult} />,
                        size: "lg",
                        draggable: true,
                    });
                } else {
                    const data = { ...form.hsCdForm.getValues(), hsCtgrItmList: grid.appHsCodeList.getData() };
                    modal.openModal({
                        content: "msg.osc.00090" /**Do you want to save ? */,
                        onConfirm: () => {
                            fetch.saveHsCtgrItmList.fetch(data);
                        },
                    });
                }
            }
        }),

        setInit: async () => {
            // OGA HS CODE LIST
            await fetch.getHsCtgrItmList.fetch();
        },
    };

    // useEffect
    useEffect(() => {
        handler.setInit();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Layout>
                        <Layout.Left>
                            <Group.Title title={t("T_ITM_CTGR")} titleSize={1}></Group.Title>
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control
                                {...form.hsCdForm.schema.srchItmCtgrTpCd}
                                onChange={(v: any) => {
                                    form.hsCdForm.setValue("itmCtgrTpCd", v);
                                    fetch.getHsCtgrItmList.fetch();
                                }}
                            />
                        </Group.Row>
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="reset"
                                onClick={() => {
                                    form.hsCdForm.reset();
                                }}
                            />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={() => {
                                    fetch.getHsCtgrItmList.fetch();
                                }}
                            />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Layout>
                        <Layout.Left>
                            <Group.Title title={t("T_HS_CD_LST")} titleSize={1}></Group.Title>
                        </Layout.Left>
                    </Layout>
                    <Layout>
                        <Layout.Left>
                            <Button
                                role="tmplDown"
                                onClick={() => {
                                    lpcoUtils.saveExcelDownload(
                                        process.env.REACT_APP_API_OSCI + "/api/v1/osci/lpco/hscd/ctgr/excel-template",
                                        {},
                                    );
                                }}
                            >
                                Template Download
                            </Button>
                            <Button
                                role="excelUpload"
                                onClick={async () => {
                                    const data =
                                        (await grid.appHsCodeList.importExcel({
                                            headers: 1,
                                            bindings: {
                                                A: "itmCtgrTpCd",
                                                B: "hsCd",
                                                C: "rmrk",
                                                D: "appdStrtDt",
                                                E: "appdEndDt",
                                            },
                                            sheet: 0,
                                        })) || [];
                                    //시트명, 헤더 ROW 수
                                    grid.appHsCodeList.setData(
                                        comnUtils.getGridData([...grid.appHsCodeList.getData(), ...data]),
                                    );
                                }}
                            ></Button>
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="gridAdd"
                                onClick={() => {
                                    //alert("test");
                                    grid.appHsCodeList.addRow({
                                        appdStrtDt: comnUtils.dateToString(new Date(), "date"),
                                        itmCtgrTpCd: form.hsCdForm.getValue("srchItmCtgrTpCd"),
                                    });
                                }}
                            ></Button>
                            <Button
                                role="gridDelete"
                                onClick={() => {
                                    handler.click_Btn_DeleteGridAppHsCodeList();
                                }}
                            ></Button>
                        </Layout.Right>
                    </Layout>

                    <Group.Section>
                        <Grid {...grid.appHsCodeList.grid} data={hsCdList} render={render.hsCdList} />
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Left></Layout.Left>
                        <Layout.Right>
                            <Button
                                role="save"
                                onClick={() => {
                                    handler.saveHsCtgrItmList();
                                }}
                            />
                            {/* <Button role="submit" onClick={() => {}} /> */}
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
        </Page>
    );
};
